import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from '../contexts/Language';

export const Validator = {

  Valid(data, ref = null) {
    let error = Object.entries(data).length === 0 ? { error: true, message: 'Invalid entries' } : { error: false, message: '' };

    try {
      Object.keys(data).forEach(key => {
        const validator = Validator.Rules[key];

        if (validator) {
          if (validator.Invalid(data[key])) {
            error = {
              error: true,
              message: validator.Message,
            };

            if (ref !== null) {
              ref.current.elements[key].focus();
            }

            throw new Error();
          }
        }
      });
      // eslint-disable-next-line no-empty
    } catch { }

    return error;
  },
  Rules: {
    AccountLogin: {
      Invalid: value => Validator.Conditions.Required(value),
      Message: 'Invalid Login ID',
    },
    login: {
      Invalid: value => Validator.Conditions.Required(value) || Validator.Conditions.Numeric(value),
      Message: 'Invalid Login ID',
    },
    Password: {
      Invalid: value => Validator.Conditions.Required(value),
      Message: 'Password can not be empty.',
    },
    Email: {
      Invalid: value => !(/[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/.test(value)),
      Message: 'Invalid Email Address.',
    },
    amount: {
      Invalid: value => Validator.Conditions.Required(value) || value <= 0 || Validator.Conditions.Numeric(value),
      Message: 'Invalid amount.',
    },
    fromAccount: {
      Invalid: value => Validator.Conditions.Required(value),
      Message: 'Please select From Account!',
    },
    toAccount: {
      Invalid: value => Validator.Conditions.Required(value),
      Message: 'Please select Account!',
    },
    accountID: {
      Invalid: value => Validator.Conditions.Required(value),
      Message: 'Please enter your Account ID!',
    },
    secureID: {
      Invalid: value => Validator.Conditions.Required(value),
      Message: 'Please enter your Secure ID!',
    },
    bankCode: {
      Invalid: value => Validator.Conditions.Required(value),
      Message: 'Please select Bank!',
    },
    transferType: {
      Invalid: value => Validator.Conditions.RequiredArray(value),
      Message: 'Please select Transfer Type!',
    },
    psp: {
      Invalid: value => Validator.Conditions.Required(value),
      Message: 'Please select PSP!',
    },
    description: {
      Invalid: value => Validator.Conditions.Required(value),
      Message: 'Description can not be empty!',
    },
  },
  Conditions: {
    Required(value) {
      return (value === null || value === '' || value === undefined);
    },
    RequiredArray(value) {
      return (value.length < 1);
    },
    Max(value, max) {
      return (value > max);
    },
    Min(value, min) {
      return (value < min);
    },
    Numeric(value) {
      // eslint-disable-next-line no-restricted-globals
      return isNaN(value);
    },
    MaxLength(value, length) {
      return (value.toString().length > length);
    },
    MinLength(value, length) {
      return (value.toString().length < length);
    },
  },


};

export const ErrorMessage = props => {
  const { Validation, className } = props;
  return (
    <div className={`col-md-12 ${(Validation.error ? '' : 'd-none')}`}>
      <div className={`alert alert-danger alert-dismissible fade show mb-3 mt-2 ${(className || '')}`} role="alert">
        <strong>
          <i className="fas fa-exclamation-triangle mr-1" />
          <span>Error !</span>
        </strong>
        {Translate(Validation.message)}
      </div>
    </div>
  );
};

ErrorMessage.propTypes = {
  Validation: PropTypes.object.isRequired,
  className: PropTypes.string,
};

ErrorMessage.defaultProps = {
  className: '',
};

export const VRules = (Validator.Rules);
export const VConditions = (Validator.Conditions);
